/**
 * The show/hide eye, in one place.
 *
 * Lifted out of Input.jsx, which drew it inline for the password reveal. A
 * second copy was about to be drawn for the payment-details reveal in Settings,
 * and two hand-inlined SVGs of the same icon drift — one gets a stroke-width
 * tweak and the app quietly has two eyes.
 *
 * `off` draws the struck-through variant. Sizing follows `currentColor` and the
 * `size` prop, so a caller styles it by styling its button.
 *
 * Purely decorative: it is always inside a button that carries the real label,
 * so it is aria-hidden and never announced on its own.
 */
export default function EyeIcon({ off = false, size = 18, className = '' }) {
  return (
    <svg
      className={className || undefined}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {off ? (
        <>
          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.6 21.6 0 0 1 5.06-5.94M9.9 4.24A10.4 10.4 0 0 1 12 4c7 0 11 7 11 7a21.6 21.6 0 0 1-2.68 3.79M14.12 14.12a3 3 0 1 1-4.24-4.24" />
          <path d="M1 1l22 22" />
        </>
      ) : (
        <>
          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
          <circle cx="12" cy="12" r="3" />
        </>
      )}
    </svg>
  );
}
